import { render, staticRenderFns } from "./PersonalityReport.vue?vue&type=template&id=422eb164&"
import script from "./PersonalityReport.vue?vue&type=script&lang=js&"
export * from "./PersonalityReport.vue?vue&type=script&lang=js&"
import style0 from "./PersonalityReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports